import React from 'react'
import {Avatar} from 'antd'
import {Link} from 'react-router-dom'

const MainAvatar = ({user}) => (
  <Link to='/home/profile'>
    <Avatar>
      {user.name ? user.name : user.surname ? user.surname : user.email.split('@')[0]}
    </Avatar>&nbsp;&nbsp;<span>
      {(user.name || user.surname) ? `${user.name} ${user.surname}` : user.email}
    </span>
  </Link>
)

export default MainAvatar
